import DiscoverHistorics from './themes/DiscoverHistoricsLight.css';
import HistoricsSearchForm from './containers/HistoricsSearchForm/themes/HistoricsSearchFormLight.css';
import RecentSearch from './components/RecentSearch/themes/RecentSearchLight.css';
import SearchRow from './components/RecentSearch/themes/SearchRowLight.css';
import AdditionalFilters from './components/AdditionalFilters/themes/AdditionalFiltersLight.css';
import FilterButtonGroup from
  './components/HistoricsLineChart/components/FilterButtonGroup/themes/FilterButtonGroupLight.css';
import FilterButton from './components/HistoricsLineChart/components/FilterButtonGroup/themes/FilterButtonLight.css';
import HistoricsLineChart from './components/HistoricsLineChart/themes/HistoricsLineChartLight.css';
import FFBEditor from './components/FFBEditor/themes/FFBEditorLight.css';
import FFBInfoBanner from './components/FFBInfoBanner/themes/FFBInfoBannerLight.css';
import MfeIconWrapper from './components/MfeIconWrapper/themes/MfeIconWrapperLight.css';

import KeywordTranslation from './components/KeywordTranslation/themes/KeywordTranslationLight.css';
import KeywordPill from './components/KeywordTranslation/themes/KeywordPillLight.css';

export default {
  DiscoverHistorics,
  HistoricsSearchForm,
  RecentSearch,
  SearchRow,
  AdditionalFilters,
  FilterButtonGroup,
  FilterButton,
  HistoricsLineChart,
  FFBEditor,
  FFBInfoBanner,
  MfeIconWrapper,
  KeywordPill,
  KeywordTranslation
};
